module.exports = __webpack_public_path__ + "static/media/redecorating.ca00dc65.svg";